import { render, staticRenderFns } from "./dialog-cancel.vue?vue&type=template&id=0aba511b&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dialog-cancel.vue"
export default component.exports